const titles = new WeakMap();

function fitTitle(element, state) {
    const width = element.clientWidth;
    if (width === 0) return;
    element.style.whiteSpace = "nowrap";
    const steps = Math.round((state.maxFontSize - state.minFontSize) / state.stepSize);
    for (let index = 0; index <= steps; index++) {
        const size = Math.max(state.minFontSize, state.maxFontSize - index * state.stepSize);
        element.style.fontSize = `${size}px`;
        if (element.scrollWidth <= width) return;
    }

    element.style.whiteSpace = "normal";
    const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
    for (let index = 0; index <= steps; index++) {
        const size = Math.max(state.minFontSize, state.maxFontSize - index * state.stepSize);
        element.style.fontSize = `${size}px`;
        if (element.scrollWidth <= width && element.scrollHeight <= lineHeight * state.maxLines + 1) return;
    }
    element.style.fontSize = `${state.minFontSize}px`;
}

export function updatePaywallHeaderTitle(element, minFontSize, maxFontSize, stepSize, maxLines) {
    const text = element.textContent;
    const lineHeight = element.style.lineHeight;
    const fontWeight = element.style.fontWeight;
    let state = titles.get(element);
    if (state && state.text === text && state.lineHeight === lineHeight && state.fontWeight === fontWeight &&
        state.minFontSize === minFontSize && state.maxFontSize === maxFontSize &&
        state.stepSize === stepSize && state.maxLines === maxLines) return;
    if (!state) {
        state = { frame: null };
        state.schedule = () => {
            if (state.frame !== null) return;
            state.frame = requestAnimationFrame(() => {
                state.frame = null;
                fitTitle(element, state);
            });
        };
        // Fit after layout; scheduling also prevents synchronous ResizeObserver feedback.
        state.observer = new ResizeObserver(state.schedule);
        state.observer.observe(element);
        titles.set(element, state);
    }
    Object.assign(state, { minFontSize, maxFontSize, stepSize, maxLines, text, lineHeight, fontWeight });
    state.schedule();
}

export function releasePaywallHeaderTitle(element) {
    const state = titles.get(element);
    if (!state) return;
    state.observer.disconnect();
    if (state.frame !== null) cancelAnimationFrame(state.frame);
    titles.delete(element);
}
